module.exports = "<ng-transclude></ng-transclude> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-accordion/dv-accordion.html
// module id = 6IWY
// module chunks = 0